import React, { useContext, useEffect, useState } from "react";
import styles from "./CreateNewButton.module.css";
import AssetsPack from "../../../../../util/AssetsPack";
import CustomButton, {
  ButtonType,
} from "../../../../../components/button/CustomButton";
import { useTranslation } from "react-i18next";
import CategorySection from "../../sideMain/contextList/CategorySection";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../store/common/hooks";
import { DialogContext } from "../../../../../context/DialogContext";
import {
  DialogShownFromType,
  DialogStyle,
} from "../../../../../components/dialog/Dialog";
import { CreateKnowledge } from "../../../../../api/KnowledgeContentApiCall";
import { SideCardType } from "../../../../../util/QuestionStatus";
import { fetchConversations } from "../../../../../store/conversations.slice";
import { setCallApproveApi } from "../../../../../store/context.slice";

const CreateNewButton = () => {
  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState("");
  const [isFormVisible, setFormVisible] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState<number>(0);
  const [selectedSubCategory, setSubSelectedCategory] = useState<number>(0);
  const reduxContextSelected = useAppSelector(
    (state) => state.context.isContextSelected
  );
  const { showDialog } = useContext(DialogContext);
  const reduxApproveApiCall = useAppSelector(
    (state) => state.context.callApproveApi
  );
  const dispatch = useAppDispatch();
  const statusClicked = useAppSelector((s) => s.ui.statusClicked);

  useEffect(() => {
    if (reduxApproveApiCall) {
      submitApiCall();
      dispatch(setCallApproveApi({ isSelected: false }));
    }
  }, [reduxApproveApiCall]);

  useEffect(() => {
    setFormVisible(reduxContextSelected);
  }, [reduxContextSelected]);

  const changeFormState = (state?: boolean) => {
    state ? setFormVisible(state) : setFormVisible(!isFormVisible);
  };

  const handleQuestionChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setQuestion(e.target.value);
  };

  const handleAnswerChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setAnswer(e.target.value);
  };

  const submitApiCall = async () => {
    setFormVisible(false);

    await CreateKnowledge(
      selectedCategory,
      selectedSubCategory,
      question,
      answer
    );

    if (statusClicked == SideCardType.NeedApproval) {
      dispatch(fetchConversations());
    }

    setAnswer("");
    setQuestion("");
  };

  const handleSubmit = async (
    e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>
  ) => {
    e.preventDefault();
    if (question?.trim() !== "" && answer?.trim() !== "") {
      showDialog(
        DialogStyle.Default,
        0,
        question.trim(),
        answer.trim(),
        DialogShownFromType.CreateNew
      );
    }
  };

  const InputContainer = (
    placeholder: string,
    text: string,
    setText: (e: React.ChangeEvent<HTMLTextAreaElement>) => void
  ) => {
    return (
      <div className={styles["input-container"]}>
        {/* Input Field */}
        <textarea
          value={text}
          onChange={setText}
          className={styles["input"]}
          autoFocus
          onFocus={(e) => e.target.select()}
          rows={4}
          style={{ resize: "vertical" }}
          placeholder={placeholder}
        />
      </div>
    );
  };

  const { t } = useTranslation();

  return (
    <div className={styles["mainContainer"]}>
      <button
        className={styles["createNewButton"]}
        onClick={() => !isFormVisible && changeFormState(true)}
      >
        <div className={styles["iconContainer"]}>
          <img
            className={styles["icon"]}
            src={AssetsPack.icons.ICON_CREATE_NEW.default}
          />
          <span>{t("createNewButton.create_new")}</span>
        </div>
        <img
          onClick={() => changeFormState()}
          className={styles["icon"]}
          src={
            !isFormVisible
              ? AssetsPack.icons.ICON_PLUS.default
              : AssetsPack.icons.ICON_CLOSE.default
          }
        />
      </button>
      {isFormVisible && (
        <div className={styles["formSection"]}>
          {InputContainer(
            t("createNewButton.question"),
            question,
            handleQuestionChange
          )}
          {InputContainer(
            t("createNewButton.answer"),
            answer,
            handleAnswerChange
          )}

          <div className={styles["bottomSection"]}>
            <CategorySection
              onCategorySelect={setSelectedCategory}
              onSubCategorySelect={setSubSelectedCategory}
            />
          </div>

          <CustomButton
            text={t("createNewButton.submit")}
            type={ButtonType.Submit}
            onClick={handleSubmit}
            disabled={question == "" || answer == ""}
          />
        </div>
      )}
    </div>
  );
};

export default CreateNewButton;
